var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"700px"},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},[_c('v-card',[_c('v-card-title',[_vm._v("Salvar novo template de e-mail")]),_c('v-card-text',{staticClass:"pb-0"},[_c('v-row',[_c('v-col',{staticClass:"pb-0"},[_c('v-text-field',{attrs:{"placeholder":"Nome do template","label":"Nome do template","outlined":"","no-resize":"","error-messages":_vm.errorTitle},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1)],1)],1),_c('v-card-actions',[_c('mf-action-buttons',{staticClass:"pb-1",attrs:{"primary-button":{
          text: 'Criar template',
          action: _vm.createEmailTemplate,
          isVisible: true,
          isLoading: _vm.loadingCreatingTemplate,
        },"secondary-button":{
          text: 'Cancelar',
          action: _vm.close,
          isVisible: true,
        }}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }